import UIComponent from '../../common/UIComponent';
import { MUTILSUBTITLE, VODSUBTITLE } from '../../common/Constant';
import './index.css';
import './index_h5.css';

export default class SubtitleBtn extends UIComponent {
  constructor(elementId, interfaces, videoId, isMobile = false) {
    super();
    //根据isMobile参数，兼容PC和移动端两种样式
    this.isMobile = isMobile;
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.videoId = videoId;
    this.Lang = interfaces.language;

    //todo: 直播字幕变量命名
    this.mutilSubtitle = null;
    this.currentSubtitleName = null;
    //todo: 点播字幕变量命名
    this.subtitleList = null;
    this.currSubtitle = null;
    this.init();
    this.interfaces.on(VhallPlayer.LIVESUBTITLE_OPENED, res => {
      this.definitionBtn?.classList.remove('full');
    });
    this.interfaces.on(VhallPlayer.LIVESUBTITLE_CLOSED, res => {
      this.definitionBtn?.classList.add('full');
    });
    this.interfaces.on(VhallPlayer.OPEN_SUBTITLE, res => {
      this.definitionBtn?.classList.remove('full');
    });
    this.interfaces.on(VhallPlayer.CLOSE_SUBTITLE, res => {
      this.definitionBtn?.classList.add('full');
    });
  }

  hengshuping() {
    if (window.orientation == 180 || window.orientation == 0) {
      // alert("竖屏状态！")
      if (this.definitionListPopu) {
        this.definitionListPopup.setAttribute('class', 'vhallPlayerh5-multi-subtitle-popup');
      }
    }
    if (window.orientation == 90 || window.orientation == -90) {
      // alert("横屏状态！")
      if (this.definitionListPopu) {
        this.definitionListPopup.setAttribute('class', 'vhallPlayerh5-multi-subtitle-popup-landscape');
      }
    }
  }

  init() {
    if (this.isMobile) {
      window.addEventListener(
        'onorientationchange' in window ? 'orientationchange' : 'resize',
        this.hengshuping.bind(this),
        false
      );
    }
    if (this.interfaces.isLive) {
      this.mutilSubtitle = this.interfaces.getLiveSubtitleList();
      this.currentSubtitleName = this.interfaces.getCurrentLiveSubtitleName();
      if (this.mutilSubtitle.length < 1) {
        return;
      }
    } else {
      this.currSubtitle = this.interfaces.getCurrentVodSubtitle();
      this.subtitleList = this.interfaces.getVodSubtitleList();
      if (this.subtitleList.length < 1) {
        return;
      }
    }

    // 屏中提示
    this.subtitleTip = document.createElement('div');
    this.subtitleTip.setAttribute('class', 'vh-subtitleTip-close-subtitle');
    this.subtitleTip.textContent = this.Lang.mutilSubtitle.closeSubtitle;
    this.appendChild(this.videoId, this.subtitleTip);

    //主题组件
    this.definitionComponent = document.createElement('div');
    this.definitionComponent.setAttribute(
      'class',
      this.isMobile ? 'vhallPlayerh5-multi-subtitle-component' : 'vhallPlayer-multi-subtitle-component'
    );
    this.definitionComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    //控制栏常驻按钮
    this.definitionBtn = document.createElement('span');
    this.definitionBtn.setAttribute('class', 'vhallPlayer-multi-subtitle-definitionBtn full');
    this.definitionBtn.onclick = this.handleBtnClick.bind(this);
    this.definitionComponent.appendChild(this.definitionBtn);

    //上浮框或弹出窗
    this.definitionListPopup = document.createElement('div');
    this.definitionListPopup.setAttribute(
      'class',
      this.isMobile ? 'vhallPlayerh5-multi-subtitle-popup' : 'definition-popup'
    );
    if (!this.isMobile) {
      this.definitionComponent.appendChild(this.definitionListPopup);
    } else {
      this.appendChild(this.videoId, this.definitionListPopup);
    }
    //固定的关闭栏
    this.definitionListTitle = document.createElement('div');
    this.definitionListTitle.setAttribute('class', 'definition-title');
    this.definitionListTitle.innerText = this.Lang.mutilSubtitle.title;
    this.definitionListTitle.onclick = this.closeSubtitleBtnClick.bind(this);
    this.definitionListPopup.appendChild(this.definitionListTitle);
    //可选的字幕栏
    this.definitionListBoxContainer = document.createElement('div');
    this.definitionListBoxContainer.setAttribute('class', 'definition-list-box-container');
    this.definitionListPopup.appendChild(this.definitionListBoxContainer);
    this.definitionListBox = document.createElement('ul');
    this.definitionListBox.setAttribute('class', 'mutil-list-box');
    this.definitionListBoxContainer.appendChild(this.definitionListBox);
    if (this.interfaces.isLive) {
      for (let i = 0; i < this.mutilSubtitle.length; i++) {
        const value = this.mutilSubtitle[i];
        this.definitionItem = document.createElement('li');
        value === this.currentSubtitleName ? this.definitionItem.classList.add('full') : undefined;
        this.definitionItem.setAttribute('data-subtitle', value);
        this.definitionItem.innerText = MUTILSUBTITLE[value] || 'subtitle' + i;
        this.definitionItem.onclick = this.changeSubtitleItemClick.bind(this);
        this.definitionListBox.appendChild(this.definitionItem);
      }
    } else {
      for (let i = 0; i < this.subtitleList.length; i++) {
        const value = this.subtitleList[i].lang;
        this.definitionItem = document.createElement('li');
        value === this.currSubtitle?.lang ? this.definitionItem.classList.add('full') : undefined;
        this.definitionItem.setAttribute('data-subtitle', i);
        this.definitionItem.innerText = VODSUBTITLE[value] || 'subtitle' + i;
        this.definitionItem.onclick = this.changeSubtitleItemClick.bind(this);
        this.definitionListBox.appendChild(this.definitionItem);
      }
    }

    this.insertElement(this.elementId, this.definitionComponent);
  }

  handleComponentMouseLeave() {
    if (!this.isMobile) {
      this.definitionListPopup.style.display = 'none';
    }
  }

  //控制栏常驻按钮点击
  handleBtnClick() {
    this.definitionListPopup.style.display = 'block';

    if (this.interfaces.isLive && this.mutilSubtitle.length == 1) {
      this.definitionListPopup.style.display = 'none';
      if (this.definitionBtn.classList.contains('full')) {
        this.subtitleTip.style.display = 'block';
        this.subtitleTip.textContent = this.Lang.mutilSubtitle.openSubtitle;
        setTimeout(() => {
          this.subtitleTip.style.display = 'none';
        }, 500);
        this.definitionBtn.classList.remove('full');
        this.interfaces.openLiveSubtitle();
      } else {
        this.subtitleTip.style.display = 'block';
        this.subtitleTip.textContent = this.Lang.mutilSubtitle.closeSubtitle;
        setTimeout(() => {
          this.subtitleTip.style.display = 'none';
        }, 500);
        this.definitionBtn.classList.add('full');
        this.interfaces.closeLiveSubtitle();
      }
    }

    if (!this.interfaces.isLive && this.subtitleList.length <= 1) {
      this.definitionListPopup.style.display = 'none';
      if (this.definitionBtn.classList.contains('full')) {
        this.subtitleTip.style.display = 'block';
        this.subtitleTip.textContent = this.Lang.mutilSubtitle.openSubtitle;
        setTimeout(() => {
          this.subtitleTip.style.display = 'none';
        }, 500);
        this.definitionBtn.classList.remove('full');
        this.interfaces.openVodSubtitle();
      } else {
        this.subtitleTip.style.display = 'block';
        this.subtitleTip.textContent = this.Lang.mutilSubtitle.closeSubtitle;
        setTimeout(() => {
          this.subtitleTip.style.display = 'none';
        }, 500);
        this.definitionBtn.classList.add('full');
        this.interfaces.closeVodSubtitle();
      }
    }
  }

  //关闭字幕按钮
  closeSubtitleBtnClick() {
    this.definitionListPopup.style.display = 'none';

    if (this.interfaces.isLive) {
      this.currentSubtitleName = this.interfaces.getCurrentLiveSubtitleName();
      if (this.currentSubtitleName === 'original') {
        return;
      }
      for (let i = 0; i < document.querySelectorAll('.mutil-list-box li').length; i++) {
        const value = document.querySelectorAll('.mutil-list-box li')[i];
        value.removeAttribute('class');
      }
      this.interfaces.closeLiveSubtitle();
      this.definitionListTitle.classList.add('full');
      this.definitionBtn.classList.add('full');
    } else {
      if (this.interfaces.vhallplayer.isOpenVodSubtitle) {
        for (let i = 0; i < document.querySelectorAll('.mutil-list-box li').length; i++) {
          const value = document.querySelectorAll('.mutil-list-box li')[i];
          value.removeAttribute('class');
        }
        this.interfaces.closeVodSubtitle();
        this.definitionListTitle.classList.add('full');
        this.definitionBtn.classList.add('full');
      }
    }
  }

  //切换字幕按钮
  changeSubtitleItemClick(event) {
    if (this.interfaces.isLive) {
      //切换直播字幕
      this.definitionListPopup.style.display = 'none';
      let value = event.target.getAttribute('data-subtitle');
      this.currentSubtitleName = this.interfaces.getCurrentLiveSubtitleName();
      if (this.currentSubtitleName === value) {
        return;
      }
      for (let i = 0; i < document.querySelectorAll('.mutil-list-box li').length; i++) {
        let mutilvalue = document.querySelectorAll('.mutil-list-box li')[i];
        mutilvalue.removeAttribute('class');
      }
      this.definitionListTitle.classList.remove('full');
      event.target.classList.add('full');
      if (this.definitionBtn.classList.contains('full')) {
        this.definitionBtn.classList.remove('full');
      }
      this.interfaces.changeLiveSubtitle(value);
    } else {
      //切换点播字幕
      let value = event.target.getAttribute('data-subtitle');
      const newSubtitle = this.subtitleList[value];

      this.definitionListPopup.style.display = 'none';
      for (let i = 0; i < document.querySelectorAll('.mutil-list-box li').length; i++) {
        let mutilvalue = document.querySelectorAll('.mutil-list-box li')[i];
        mutilvalue.removeAttribute('class');
      }
      this.definitionListTitle.classList.remove('full');
      event.target.classList.add('full');
      if (this.definitionBtn.classList.contains('full')) {
        this.definitionBtn.classList.remove('full');
      }

      this.interfaces.openSubtitle(newSubtitle);
    }
  }
}
